module.exports = __webpack_public_path__ + "img/business-outline.dd956bc1.svg";